import { useState } from 'react';
import { useAppDispatch } from "@/app/hooks";
import { AuthScreenStatus, setState } from "@/app/features/auth";
import { SearchParamsKey, useUrlParams } from "@/app/utils/search_params";

const usePhone = () => {
  const [phone, setPhoneState] = useState('');
  const [showCaptcha, setShowCaptcha] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { setUrlParam } = useUrlParams();
  const dispatch = useAppDispatch();

  const replacePhone = phone.replace(/ /g, '');

  const updatePhone = async (newPhone: string) => {
    setPhoneState(newPhone);
  };

  const phoneContainAllDigits = () => replacePhone.length <= 8;

  const sendOtp = () => {
    setError(null);
    setShowCaptcha(true);
  };

  const onCaptchaSuccess = () => {
    setShowCaptcha(false);
    setUrlParam(SearchParamsKey.phone, replacePhone);
    dispatch(setState(AuthScreenStatus.OTP));
  };

  const onCaptchaRateLimited = () => {
    setShowCaptcha(false);
    setError('Забагато спроб. Спробуйте пізніше.');
  };

  const onCaptchaClose = () => {
    setShowCaptcha(false);
  };

  return {
    phone,
    setPhone: updatePhone,
    loading: false,
    error,
    phoneContainAllDigits,
    sendOtp,
    showCaptcha,
    onCaptchaSuccess,
    onCaptchaRateLimited,
    onCaptchaClose,
  };
};

export default usePhone;
